interface ModalSizes {
  small: string;
  medium: string;
  large: string;
}

export const modalSizes: ModalSizes = {
  small: '400px',
  medium: '600px',
  large: '800px',
};
